.expiredPill {
    background-color: var(--expired-pill-background-color);
    color: var(--expired-pill-color);
}
